import { cn } from "@strivelabs/ui-core"

export interface NavSectionLabelProps {
  label: string
  className?: string
}

/**
 * Uppercase group heading such as WORKBENCH or INTELLIGENCE. Quiet by design
 * (30% ink, wide tracking) with a generous gap above, so groups read as
 * breaks in the list rather than as headings competing with the rows.
 */
export function NavSectionLabel({ label, className }: NavSectionLabelProps) {
  return (
    <div
      className={cn(
        "pb-1 pl-[15px] pr-1 pt-[22px] text-[11px] font-medium uppercase leading-[18px] tracking-[0.07em] text-v2-sidebar-foreground/30",
        className,
      )}
    >
      {label}
    </div>
  )
}
